import { z } from 'zod'

export const DELIVERY_LOG_STATUSES = ['delivered', 'suppressed', 'skipped', 'error'] as const

export const TIME_RANGE_PRESETS = ['24h', '7d', '30d'] as const

export const DEFAULT_TIME_RANGE: TimeRangePreset = '7d'

const StatusSchema = z.enum(DELIVERY_LOG_STATUSES)
const TimeRangeSchema = z.enum(TIME_RANGE_PRESETS)

export const DeliveryLogSearchSchema = z.object({
  user: z.string().optional(),
  event: z.array(z.string()).optional(),
  status: z.array(StatusSchema).optional(),
  range: TimeRangeSchema.optional(),
  since: z.iso.datetime().optional().catch(undefined),
  until: z.iso.datetime().optional().catch(undefined),
})

export type DeliveryLogStatus = z.infer<typeof StatusSchema>
export type TimeRangePreset = z.infer<typeof TimeRangeSchema>
export type DeliveryLogSearch = z.infer<typeof DeliveryLogSearchSchema>
